<!-- Remove Dormat Confirmation Modal -->
<gtw-confirmation-modal
  [config]="confirmModalConfig"
  [visible]="showConfirmModal"
  (confirmed)="onConfirm()"
  (cancelled)="onCancel()"
  (closed)="onCancel()">
</gtw-confirmation-modal>
